import React from 'react'
import PropTypes from 'prop-types'

// Use a function to return the default state to avoid accidental mutation.
const getDefaultValues = () => ({
  error: false,
  loading: false,
  success: false,
})

/*
 * This component replaces the need to have redux stores
 * for error, loading, and success states of requests.
 */
export default class RequestManager extends React.Component {
  static propTypes = {
    children: PropTypes.func,
  }

  state = getDefaultValues()

  reset = () => {
    this.setState(getDefaultValues())
  }

  setStart = () => {
    this.setState({
      error: false,
      loading: true,
      success: false,
    })
  }

  setError = e => {
    this.setState({
      error: e,
      loading: false,
      success: false,
    })
  }

  setSuccess = () => {
    this.setState({
      error: false,
      loading: false,
      success: true,
    })
  }

  render() {
    return this.props.children
      ? this.props.children({
          reset: this.reset,
          setStart: this.setStart,
          setError: this.setError,
          setSuccess: this.setSuccess,
          ...this.state,
        })
      : null
  }
}
